<template>
  <b-modal
    :title="`${title}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <EditFileForm :title="title" v-if="isEdit" />
    <NewFilesForm :title="title" v-else />
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import EditFileForm from '@/febos/global/documentManagement/components/EditFileForm';
import NewFilesForm from '@/febos/global/documentManagement/components/NewFilesForm';

export default {
  name: 'FileFormView',
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
    };
  },
  components: {
    EditFileForm,
    NewFilesForm
  },
  mounted() {
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ])
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getSelectedFolderId',
      'getSelectedElement',
      'getTreeElements',
      'getRepositories'
    ]),
    showModal: {
      get() {
        return this.modalName === 'fileFormED';
      },
      set() {
        this.closeModal();
      }
    },
    title() {
      let response = '';
      const prep = this.isEdit ? 'Editar' : 'Agregar documento a';
      if (this.getSelectedFolderId) {
        response = `${prep} ${this.getTreeElements[this.getSelectedFolderId].nombre}`;
      }
      if (this.getSelectedRepositoryId) {
        response = `${prep} ${this.getRepositories[this.getSelectedRepositoryId].nombreRepositorio}`;
      }
      if (this.getSelectedElement && this.isEdit) {
        response = `${prep} ${this.getSelectedElement.name}`;
      }
      return response;
    }
  }
};
</script>
